{
    "CustomisePopupTitle": "Beheerdersrol aanpassen",
    "FooterActionsSubmit": "Indienen",
    "FooterActionsCancel": "Annuleren",
    "FooterActionsHelp": "Helpen?",
    "TableHeadingAdminAccess": "Beheertoegang",
    "HeadingAdministrate": "administreren",
    "HeadingView": "Visie",
    "HeadingAdd": "Toevoegen",
    "HeadingModify": "Wijziging",
    "HeadingDelete": "Verwijderen",
    "EntryCme": "Instellingen voor centrale beheeromgeving.",
    "EntryDevices": "Apparaten",
    "EntryDevicesSub": "(Extensies \/ Groepen \/ Overige apparaten)",
    "EntryAgents": "agenten",
    "EntryDirectory": "Directory's",
    "EntryApplicationUsers": "Gebruikers in bulk uploaden",
    "EntryCodes": "Codes",
    "EntryTelServers": "Telefonieservers",
    "EntryPartition": "partities",
    "EntryOmnichannel": "Omnichannel",
    "EntryRecordings": "Opnemen",
    "EntryMessages": "Berichten",
    "EntryDatabase": "Database",
    "TableHeadingStatusTools": "Toegang tot status en tools",
    "HeadingSection": "Sectie",
    "EntryLicences": "Licenties",
    "EntryLogging": "Loggen",
    "EntryLogManagement": "Instellingen voor centrale beheeromgeving.",
    "EntryAuditTrail": "Audit",
    "EntryTelephoneModuleStatus": "Status telefoonmodule",
    "EntryOmnichannelStatus": "Omnichannel-status",
    "EntryCallControl": "Oproepbeheer",
    "EntryServerStatus": "Server Status",
    "TableHeadingActions": "Acties",
    "HeadingAction": "Actie",
    "HeadingAllowed": "Toegestaan",
    "EntryCopyReportsTo": "Rapporten kopiëren naar...",
    "EntrySignInAs": "Inloggen als",
    "EntryBillingFilesDownload": "Facturerings-CDR's",
    "EntryBillingSummary": "Factureringsoverzicht",
    "EntryChangeLicenceLevel": "Serviceniveau-instellingen",
    "SyncPartition": "Synchronisatie aangevraagd",
    "ViewChangedWarning": "Zonder de optie Weergeven kan {} alleen {} zijn met behulp van de API.",
    "Update": "bijgewerkt",
    "Delete": "verwijderd",
    "ViewChangeOr": "of hier slepen en neerzetten.",
    "CustomiseRole_Add": "toegevoegd",
    "NAME": "CustomiseRole",
    "EntryUserRole": "Gebruikersrollen",
    "EntryChangeTelephonyServerBillingStatus": "De factureringsstatus van de telefonieserver wijzigen",
    "EptAccess": "Eenvoudige provisioneringstool",
    "EntryLogFilesDownload": "Logbestanden downloaden",
    "TelSysSyncRestrictions": "Maximale synchronisatieparameters wijzigen",
    "CMEBrandingConfig": "CME-brandingconfiguratie",
    "EntryCrm": "CRM-beheer",
    "EntryClientConfig": "Clientconfiguratie",
    "EditOwningCMEDomainProfile": "CME-domeinprofiel bewerken",
    "EditOwningCMEBranding": "Bewerk CME-branding",
    "EditOwningCMEProvisioning": "CME-provisioning bewerken (Service Pack-synchronisatie)",
    "EditOwnCMEDomainProfile": "Bewerk uw eigen CME-domeinprofiel",
    "EditOwnCMEBranding": "Bewerk uw eigen CME-branding",
    "EditOwnCMEProvisioning": "Bewerk eigen CME-inrichting",
    "Policy": "Beleid"
}